import { render, staticRenderFns } from "./JobInfoPanel.vue?vue&type=template&id=27892e76&scoped=true"
import script from "./JobInfoPanel.vue?vue&type=script&lang=ts"
export * from "./JobInfoPanel.vue?vue&type=script&lang=ts"
import style0 from "./JobInfoPanel.vue?vue&type=style&index=0&id=27892e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27892e76",
  null
  
)

export default component.exports